import { Injectable } from '@angular/core'
import { IUser } from '../models/IUser'
import { Subject, Observable } from 'rxjs/Rx'
import { Http, Response, Headers, RequestOptions } from '@angular/http'
import { ActivatedRoute, Router } from '@angular/router';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/delay';
import { AppSettings } from '../shared/app-settings';

@Injectable()
export class AuthService {
    currentUser = {
        UserId: 0,
        UserName: ""
    }
    Status: number = 0
    Description: string = ""
    IcurrentUser: Observable<any>;
    constructor(private http: Http,
        private route: ActivatedRoute,
        private router: Router) { }
    loginUser(userName: string, password: string
    ) {
        this.currentUser.UserId = 123
        this.currentUser.UserName = userName
        console.log(this.currentUser)
        localStorage.setItem('currentUser', JSON.stringify({ id: this.currentUser.UserId }));
    }

    login(data) {
        const _urlLogin: string = AppSettings.API_ENDPOINT + "/api/User/LogIn";
        this.IcurrentUser = this.serverCall(data)
            .do(res => {
                this.Status = res.Status;

                this.Description = res.Description;
            })
            .map(res => res.Message);

        if (this.Status == 1) {
            console.log(this.IcurrentUser)
            return this.Status;
        }
        else {
            return this.Status;
        }
    }

    serverCall(data): Observable<any> {
        const _urlLogin: string = AppSettings.API_ENDPOINT + AppSettings.LOGIN_API;
        let encoded_data = JSON.stringify(data);
        console.log(encoded_data)
        let aaa = JSON.parse(encoded_data);
        console.log(encoded_data)
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
        let options = new RequestOptions({ headers: headers });
        let myResponse: any
        return this.http.post(_urlLogin, encoded_data, options).
            map((response: Response) => {
                return <any[]>response.json();
            }).catch(this.handleError);
    }


    ChangePassword(data): Observable<any> {
        const _urlLogin: string = AppSettings.API_ENDPOINT + "/api/User/ChangePassword";
        let encoded_data = JSON.stringify(data);
        console.log(encoded_data)
        let aaa = JSON.parse(encoded_data);
        console.log(encoded_data)
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
        let options = new RequestOptions({ headers: headers });
        let myResponse: any
        return this.http.post(_urlLogin, encoded_data, options).
            map((response: Response) => {
                return <any[]>response.json();
            }).catch(this.handleError);
    }

    private handleError(error: Response) {
        return Observable.throw(error.statusText);
    }

    isAuthenticated() {
        var cUser = JSON.parse(localStorage.getItem('currentUser'));
        if (cUser && cUser != "undefined" && cUser != null) {
            console.log("true")
            return true;
        }
        else {
            console.log("true")
            return false
        }

    }

    logout() {
        localStorage.removeItem('currentUser')
        this.router.navigate(['pages/login']);
    }

    public getCurrentUser() {
        var cUser = JSON.parse(localStorage.getItem('currentUser'));
        if (cUser != null) {
            return cUser.user;
        }
        else return null
    }

    public currentUserId(): number {
        var cUser = JSON.parse(localStorage.getItem('currentUser'));
        if (cUser != null) {
            return cUser.user.UserId;
        }
        else return 0
    }
}


// WEBPACK FOOTER //
// ./src/app/users/auth.service.ts